<div translate="no" class = "textModalCUI container-modal">
  <div class= "text-parrafo normalColor">
    <div class = "padding-bottom">
      Declaro estar en conocimiento que, al realizar un rescate total, se pondrá
      fin a mi póliza de seguro, perdiendo todas mis coberturas contratadas
      y por lo tanto:
    </div>
    <div class="detail colorLightGray">
    <div class= "padding-parrafo">
      1.- En caso de tener cobertura de fallecimiento y/o muerte accidental;
      mis beneficiarios no recibirán indemnización.
    </div>
    <div class= "padding-parrafo">
      2.- En caso de tener cobertura adicional de salud con asegurados dependientes,
      tanto ellos como yo dejaremos de estar protegidos.
    </div>
    <div class= "padding-parrafo">
      3.- Si contrato un nuevo seguro en Vida Security o en otra compañía,
      nuevamente deberá ser evaluado mi estado de salud, lo que puede provocar:
      ser rechazo o sobreprimado.
    </div>
    <div>
      4.- Si contrato un nuevo seguro en otra compañía tendré que pagar las primas
      en base a mi edad actual, la cual es mayor a la que tenia al contratar el
      seguro en Vida Security. Además, deberé pagar nuevamente los costos
      administrativos que generalmente se pagan durante los primeros años de vigencia.
    </div>
  </div>
  </div>

  <div class ="checkbox-cui">
    <ds-checkbox
    type="s1"
    family="primary" 
    name="grupo"
    value="s1"
    [checked] = checked
    (onchange)="setValuePopUp($event)"
    >
    </ds-checkbox>
    <p style="padding-top: 2px;">Estoy de acuerdo </p>
  </div>
  

  <div class="buttons-popup buttons-confirmar">
      <ds-button (click)="closePopUp()" class="float-end"  variant="secondary">
        <span slot="text2">Volver</span>
      </ds-button>
    <ds-button [disabled]= "!popUpService.checkBoxCui.value" (click)="nextPopUp()" class="float-end"  variant="primary"
    >
      <span slot="text2">Continuar</span>
    </ds-button>
  </div>

</div>
